export default __webpack_public_path__ + "static/media/undo.9be991ad.svg";